import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Faq.css";
import {
  CircleCheckBig,
  Facebook,
  ChevronRight,
  ChevronDown,
  Play,
  X,
  Plus,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";
function Faq() {
  const [isOpen, setIsOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "Alright, but what exactly do you do?",
      answer:
        "As a creative agency, we work with you to develop solutions to address your brand needs. That includes various aspects of brand planning and strategy, marketing, and design.",
    },
    {
      id: 2,
      question: "What services does Q-Flyers provide?",
      answer:
        "Q-Flyers offers a Digital Menu Card SaaS, a cloud-based platform that helps restaurants, cafes, and food establishments create, manage, and display digital menus for their customers.",
    },
    {
      id: 3,
      question: "How does Q-Flyers help businesses?",
      answer:
        "Q-Flyers simplifies business operations by replacing traditional paper menus with digital menu solutions, allowing businesses to update their menus in real time and enhance customer experience.",
    },
    {
      id: 4,
      question: "Who can benefit from Q-Flyers?",
      answer:
        "Any food-related business, including restaurants, cafes, food trucks, and hotels, can benefit from Q-Flyers. Our platform is scalable and user-friendly for businesses of all sizes.",
    },
    {
      id: 5,
      question: "Why choose Q-Flyers over traditional menus?",
      answer:
        "Q-Flyers offers a more efficient, eco-friendly, and engaging way to present menus. With instant updates, customizable designs, and cloud-based access, businesses can improve their service and attract more customers.",
    },
  ];
  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <div>
      <Header />
      <div className="faq-con container">
        <p>Faq’s</p>
        <h1>Got questions?</h1>
        {faqs.map(({ id, question, answer }) => (
          <div key={id} className="faq-content mt-2">
            <div className="faq-number">
              <h1>{id < 10 ? `0${id}` : id}</h1>
            </div>
            <div className="faq-text">
              <h4 onClick={() => toggleFaq(id)} className="faq-header">
                <span>{question}</span>
                <span
                  className={`faqicon ${openFaq === id ? "faqcircle" : ""}`}
                >
                  {openFaq === id ? <X /> : <Plus />}
                </span>
              </h4>
              {openFaq === id && <div className="faq-answer">{answer}</div>}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default Faq;
